export const isEmpty = (value) => {
  if (value == null) {
    return true;
  }

  if (typeof value === "string" && value.trim().length === 0) {
    return true;
  }

  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true;
  }

  if (typeof value === "number" && Number.isNaN(value)) {
    return true;
  }

  return false;
};
